<template>

  <div class="card card-block p-25" v-bind:class="item.CSSClass">
    <div class="counter counter-lg counter-inverse">
      <router-link
        v-if="target"
        :to="_getRouteLink()">
        <div class="counter-label text-uppercase">{{ t(item.DictionaryKeyCode) }}</div>
        <span class="counter-number">{{ value }}</span>
      </router-link>


      <div
        v-if="!target"
        class="counter-label text-uppercase"
      >{{ t(item.DictionaryKeyCode) }}
      </div>

      <span
        v-if="!target"
        class="counter-number"
      >{{ value }}
      </span>

    </div>
  </div>

</template>

<script>
import RouterLinkGenerator from '../../model/wrapper/menu-link-params'

export default {
  name:  'CardBlock',
  props: ['item'],

  data () {
    return {
      value:  undefined,
      target: undefined
    }
  },

  watch: {
    'item': function (item) {
      this.value = item.FieldValues[0].value
    }
  },

  created () {
    if (this.item.Fields.length) {
      this.target = this.item.Fields[0]
    }

    if (this.item.FieldValues && this.item.FieldValues.length) {
      this.value = this.item.FieldValues[0].value
    }

  },

  methods: {
    /**
     *
     * @private
     */
    _getRouteLink () {
      return RouterLinkGenerator.getParams(this.target)
    }
  }

}
</script>

<style scoped>

</style>
